var _g, _path, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDrop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "70px",
    height: "70px",
    viewBox: "0 0 70 70",
    enableBackground: "new 0 0 70 70",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M26.27,53.56c2.415-0.041,4.855-0.066,7.242-0.059l-1.56,2.643l11.228-19.024l-13.162,6.497l-13.187-5.209 l13.139,21.095l1.786-3.026c-1.219-0.008-2.446-0.009-3.672-0.002L26.27,53.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M2.359,57h2.88c0,1-0.292,0.991-0.434,1.074c0.841-0.493,6.613-1.297,18.517-1.574l-1.213-2.055 l-0.562-0.901C2.363,54.087,2.359,56,2.359,57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M55.339,57h2.881c0-1,0-2.823-18.879-3.405c-0.401-0.013-0.812-0.021-1.222-0.031l-1.757,2.977 c0.979,0.021,1.948,0.045,2.889,0.074l0.045-1.429l-0.044,1.444c10.682,0.329,15.732,0.979,16.521,1.441 C55.632,57.988,55.339,58,55.339,57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M33.512,53.501c-2.387-0.008-4.828,0.018-7.242,0.059l1.815,2.914c1.226-0.007,2.453-0.006,3.672,0.002 l0.196-0.332L33.512,53.501z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M55.34,57c0,0,0.293-0.677,0.435-0.761c-1.239,0.728-10.784,1.812-25.484,1.812 c-14.701,0-24.247-1.122-25.485-1.85C4.946,56.285,5.239,57,5.239,57h-2.88c0,2,1.261,2.52,9.077,3.187 c5.042,0.431,11.738,0.745,18.854,0.745s13.812-0.353,18.854-0.783C56.959,59.481,58.221,59,58.221,57H55.34z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M31.789,55.061h-3V36.222c0-14.735,11.989-26.724,26.726-26.724h11.635v3H55.515 c-13.082,0-23.726,10.643-23.726,23.724V55.061z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDrop);
export default __webpack_public_path__ + "static/media/iconDrop.6ba9e3ad.svg";
export { ForwardRef as ReactComponent };